// import $ from "jquery";
import { createGuid, contentMeta } from "./general_functions.js";
import "../../node_modules/leaflet/dist/leaflet.js";

const globalMapConfig = {
    start: {
        lat: 59.674060,
        lon: 10.649630
    },
    zoom: 13,
    popup_html: "Her"
};

const map__append = (id, appendTo) => {

    $(appendTo).html(`
        <div class="map" id="${id}"></div>`);


}

const map__setup = (id, lat, lon, zoom, type = "topo4") => {
    let map = L.map(id).setView([lat, lon], zoom);
    // types could be: topo4,norges_grunnkart,terreng_norgeskart,norges_grunnkart_graatone,egk

    L.tileLayer('https://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=' + type + '&zoom={z}&x={x}&y={y}', {
        attribution: '<a href="http://www.kartverket.no/">Kartverket</a>'
    }).addTo(map);
    return map;
}

export const map__singlepoi = (appendTo = "map__singlepoi", pointer = false) => {

    /* Example pointer
    {
        lat : 59.126930, 
        lon: 10.210610,
        popuptext : "mormor",
        popupopen : true
    }
    */

    let config = globalMapConfig;


    let lat = pointer.lat || config.start.lat || 59.914200;
    let lon = pointer.lon || config.start.lon || 10.737910;
    let zoom = pointer.zoom || config.zoom || 13;
    let id = config.id || createGuid();

    map__append(id, appendTo);

    let map = map__setup(id, lat, lon, zoom);

    if (pointer != false) {

        var marker = L.marker([lat, lon], {
            icon: L.divIcon({
                className: 'local-mapicon',
                shadowUrl: '//prokomresources.prokomcdn.no/client-grunt/02-standard-plugins/ssp-map/marker-shadow.png',
                html: '<span class="map__inner__shadow"></span><span class="map__inner__border"></span>',
                iconSize: [25, 25], // size of the icon
                shadowSize: [41, 41], // size of the shadow
                iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                shadowAnchor: [41, 41], // the same for the shadow
                popupAnchor: [0, -50] // point from which the popup should open relative to the iconAnchor
            })
        }).addTo(map);

        if (pointer.popuptext)
            marker.bindPopup(pointer.popuptext);

        if (pointer.popupopen === true)
            marker.openPopup()

    }
    return map;

}

export const map__portal = (appendTo) => {

    var config = globalMapConfig;

    let settings = globalMapConfig;
    let id = config.id || createGuid();
    let lat = config.start.lat || 59.914200;
    let lon = config.start.lon || 10.737910;
    let zoom = config.zoom || 13;

    map__append(id, appendTo);

    let map = map__setup(id, lat, lon, zoom);

    // const pos_options = {

    //     pointToLayer: function(feature, latlng) {
    //         return L.marker(latlng, {
    //             icon: L.divIcon({
    //                 className: 'local-mapicon ' + feature.properties.typeunit,
    //                 shadowUrl: '//prokomresources.prokomcdn.no/client-grunt/02-standard-plugins/ssp-map/marker-shadow.png',
    //                 html: '<span class="map__inner__shadow"></span><span class="map__inner__border"></span>',

    //                 iconSize: [25, 25], // size of the icon
    //                 shadowSize: [41, 41], // size of the shadow
    //                 iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
    //                 shadowAnchor: [41, 41], // the same for the shadow
    //                 popupAnchor: [0, -50] // point from which the popup should open relative to the iconAnchor
    //             })
    //         });

    //     },
    //     onEachFeature: function(feature, layerinfo) {
    //         if (feature.properties) {

    //             var content = feature.properties.popupContent;

    //             layerinfo.bindPopup(content, {
    //                 closeButton: true
    //             });


    //             if (feature.properties.id) {
    //                 markersById[feature.properties.id] = layerinfo;
    //             }

    //         }
    //     }
    // }


    getUnits((data) => {

        let geo__cat = [];
        let geojson__feature = [];

        $.each(data.listOfContent, function(number, dataobj) {

            // console.log("data",dataobj.categories);


            let cat = dataobj.categories;
            // console.log("orig cat",cat);

            $.each(cat, function(catNr, catObj) {
                let c = urlify(catObj.title);
                let id = createGuid();

                if (!geo__cat[c]) {
                    geo__cat[c] = catObj;
                    geojson__feature[c] = [];
                }

                let geodata = {
                    // "type": "Feature",
                    // "properties": {
                    //     "popupContent": "<h3 style='margin:0; padding:0; margin-bottom:10px;' data-unit='" + id + "' class='" + (pos.Name.length > 30 ? "long-text" : "") + "'>" + pos.Name + "</h3><p>" + pos.Gatenavn + "</p><div>" + pos.MainBody + url + "</div>",
                    //     "id": id,
                    //     "typeunit": urlify(b.Name),
                    //     fulldata: pos
                    // },
                    // "geometry": {
                    //     "type": "Point",
                    //     "coordinates": [pos.Longitude, pos.Latitude]
                    // }
                }

                geojson__feature[c].push(geodata);
                



            });

            let meta = JSON.parse(decodeURIComponent(dataobj.metaObject))




        });


        // var geodata = {
        //     "type": "Feature",
        //     "properties": {
        //         "popupContent": "<h3 style='margin:0; padding:0; margin-bottom:10px;' data-unit='" + countpos + "' class='" + (pos.Name.length > 30 ? "long-text" : "") + "'>" + pos.Name + "</h3><p>" + pos.Gatenavn + "</p><div>" + pos.MainBody + url + "</div>",
        //         "id": countpos,
        //         "typeunit": urlify(b.Name),
        //         fulldata: pos
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [pos.Longitude, pos.Latitude]
        //     }
        // };

    })

}


export const getUnits = (callback) => {

    let clientid = client.clientId;

    const ga = $.getJSON(window.apiUrl + `/api/PublicContentApi/getcontentlistdescending/${clientid}/mal_enhetsmal/1000/0/Title`).done((result) => {

        callback(result);



    });

};


// // document.addEventListener('DOMContentLoaded', function() {
// //     if ($("#mp_map").length > 0) {
// //             map_portal.init({ test: 0,  });
// //     }

// // });
